import(/* webpackMode: "eager" */ "/opt/render/project/src/components/animation/AnimatedDiv.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/layouts/AnimatedPageHeaderImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/opt/render/project/src/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/react-wrap-balancer/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/tiptap-parser/dist/esm/components/CodeBlockWithCopy.js");
